import React from "react";
import { Component } from "react";
import { RequestHeaders } from "../../../common/header-logo/request-header.component";
import { ACCESS_MODULE, MATRIX_INDICATOR } from "../../../../utils/rbac-constants.utils";
import { validateAccessModule } from "../../../../utils/helpers.utils";
import { planCatalogueActions } from "../../../../store/external/finance/plan-catalogue.reducer";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Selected_Index } from '../../../../constants/external-constants';
import "../finance.css";
import { TablePagination } from "../../../common/details-table/table-pagination.component";
import { DetailsDashboard } from "../../../common/details-dashboard/details-dashboard-layout";
import { NoSubscription } from "../../dashboard/no-subscription/no-subscription.component";
import { MODAL_CUSTOM_MESSAGE, TABLE_PAGINATION_KEY } from "../../../../constants/external-constants";
import { ConfirmationNotificationModal } from "../../../common/modal/confirmation-modal.component";
import PlanCatalogueView from "./plan-catalogue-view/plan-catalogue-view";

class PlanCatalogue extends Component {
    constructor(props) {
        super(props);
        this.state = {
            displaySearch: false,
            exportAlertMsg: MODAL_CUSTOM_MESSAGE.export_alert_message,
            activeTab: Selected_Index.i_Zero,
            contentIndex: Selected_Index.i_Zero,
            viewDetailPage: false,
            showCreateNewConfirmationModal: false,
            headerTitle: "plan_catalogue",
            planId: 0,
            createNew: false,
        }
    }

    onClickExtract = (e) => {
        if (window.confirm(this.state.exportAlertMsg)) {
            this.props.extractPlanCatalogue();
        }
    };

    handleSelectedIndex = (index) => {
        this.setState({ contentIndex: index })
    }
    loading = () => {
        return (
            <NoSubscription />
        );
    }
    displaySearchBox = () => {
        this.setState((prev) => ({ displaySearch: !prev.displaySearch }))
    }

    resizePage = (value) => {
        const { getPlanCatalogue, resizePlanCataloguePage } = this.props;
        resizePlanCataloguePage(value);
        getPlanCatalogue();
    }

    componentDidMount() {
        this.props.getPlanCatalogue();
        this.changeHeaderTitle();
    }
    componentWillUnmount() {
        this.props.setDefaultPlanCatalogue();
        this.props.getPlanCatalogue(0, true)
    }

    applyFilter = (isApply) => {
        const { getPlanCatalogue, applyPlanCatalogueFilter } = this.props;
        applyPlanCatalogueFilter(isApply);
        getPlanCatalogue();
    }


    handleCreateNew(buttonType) {
        if (buttonType === "ok") {
            this.setState({
                viewDetailPage: true,
                createNew: !this.state.createNew,
                showCreateNewConfirmationModal: false },
                () => {
                    const currentViewDetailPage = this.state.viewDetailPage;
                    this.changeHeaderTitle(currentViewDetailPage)
                });
        } else {
            this.setState({ showCreateNewConfirmationModal: false })
        }
    }


    handleCreateNewAction = () => {
        this.setState({
            showCreateNewConfirmationModal: true,
            planId: 0
        })
        this.changeHeaderTitle();
        this.props.resetFinancePlanForm();
    }

    handleCloseForm = () => {
        this.setState({
            viewDetailPage: false,
            planId: 0,
            createNew: false
        }, this.changeHeaderTitle);
        this.props.resetFinancePlanForm();
    }

    handleRowClick = () => {
        this.setState(
            { viewDetailPage: true },
            () => {
                const currentViewDetailPage = this.state.viewDetailPage;
                this.changeHeaderTitle(currentViewDetailPage);
            }
        );
    };

    getData = (isShow, rowItem) => {  
        
        if (rowItem != null) {
            this.setState({ 
                viewDetailPage: isShow
                , planId: rowItem.PlanID
            },this.changeHeaderTitle);
        }
        else {
            this.setState({ viewDetailPage: isShow },this.changeHeaderTitle);
        }
        
    }
    
    changeHeaderTitle() {
        if (this.state.viewDetailPage || this.state.createNew) {
            this.setState({ headerTitle: "plan_details_view" })
        } else {
            this.setState({ headerTitle: "plan_catalogue" })
        }
    }


    render() {

        const { planCatalogue, getPlanCatalogue, setPlanCatalogueColSearchStr, sortPlanCatalogueItems, saveRateCatalogueCustomCols, addPlanCatalogueFilter, removePlanCatalogueFilter } = this.props;
        const { viewDetailPage, headerTitle } = this.state;

        let isReadOnly = !validateAccessModule(MATRIX_INDICATOR.MatrixId, [ACCESS_MODULE.MatrixIdFinancePlanCatalogueDashboardR])
        let isReadAndExtractOnly = !validateAccessModule(MATRIX_INDICATOR.MatrixId, [ACCESS_MODULE.MatrixIdFinancePlanCatalogueDashboardRE])
        let isReadAndWrite = !validateAccessModule(MATRIX_INDICATOR.MatrixId, [ACCESS_MODULE.MatrixIdFinancePlanCatalogueDashboardRW])
        const { Selected, Available, Default } = this.props.planCatalogue.planCatalogueItems.Columns;
        return (
            <div className="invoice-wrapper-container inventory-report-component" >
                <ConfirmationNotificationModal
                    show={this.state.showCreateNewConfirmationModal}
                    message={MODAL_CUSTOM_MESSAGE.create_new_plan}
                    title={'Add New'}
                    handleModal={this.handleCreateNew.bind(this)}
                    customClass={'comment-notification-modal modal-text-bold'}
                />

                <RequestHeaders headerTitle={headerTitle} />
                <div className="request-table data-table fit-width">
                    {viewDetailPage ?
                            <PlanCatalogueView
                                  closeFormAction={this.handleCloseForm}
                                  planId={this.state.planId}
                                  getPlanCatalogue={getPlanCatalogue}
                                  //Access Type
                                  isReadOnly={isReadOnly}
                                  isReadAndExtractOnly={isReadAndExtractOnly}
                                  isReadAndWrite={isReadAndWrite}
                                  isCreateNew = {this.state.createNew}

                        />
                        :
                        <>
                            <DetailsDashboard
                                // Filter Properties
                                data={planCatalogue.planCatalogueItems.TableFilterData}
                                translation={""}
                                addAction={addPlanCatalogueFilter}
                                removeAction={removePlanCatalogueFilter}
                                applyAction={this.applyFilter}
                                customClassName={"cost-allocation"}
                                //CreateNew Action
                                createNewAction={this.handleCreateNewAction}

                                //View Search Textbox
                                viewSearchAction={this.displaySearchBox}

                                //Customize Column
                                firstList={Available}
                                secondList={Selected}
                                defaultList={Default}
                                saveAction={saveRateCatalogueCustomCols}

                                //Extract Button
                                extractAction={(e) => this.onClickExtract(e)}

                                //Access Type
                                isReadOnly={isReadOnly}
                                isReadAndExtractOnly={isReadAndExtractOnly}
                                isReadAndWrite={isReadAndWrite}
                            >
                                {
                                    planCatalogue.isPlanCatalogueLoaded? 
                                    <TablePagination  
                                        key={TABLE_PAGINATION_KEY.planCatalogue}
                                        classNameWrapper="overflow-auto"
                                        columns={planCatalogue.planCatalogueItems.Headers}
                                        pageList={planCatalogue.planCatalogueItems.Data}
                                        pages={planCatalogue.planCatalogueItems.Pagination}
                                        rowClickAction={(value) => {this.getData(true, value)}}
                                        paginationAction={getPlanCatalogue} 
                                        onColumnClick={sortPlanCatalogueItems} 
                                        onColumnSearch={() => getPlanCatalogue(0)} 
                                        onColumnSearchChange={setPlanCatalogueColSearchStr} 
                                        isColSearchShow={this.state.displaySearch}
                                        resizePage={this.resizePage}
                                        totalPage={planCatalogue.planCatalogueItems.Pagination.TotalEntries}
                                        hideStatusIcon={true}
                                    />
                                    :
                                    this.loading()
                                }
                            </ DetailsDashboard >
                        </>
                    }
                </div>
            </div>
        )
    }
}

export default withRouter(connect(
    state => {
        const { planCatalogue } = state;
        return {
            planCatalogue
        };
    },
    dispatch => bindActionCreators(
        Object.assign({}, planCatalogueActions),
        dispatch
    )
)(PlanCatalogue));